export default class Header {
  static exec() {
    const els = document.querySelectorAll('[data-component="header"]');
        els.forEach(function (el) {
            new Header(el);
        });
  }

  constructor(el) {
    let self = this;
    this.el = el;
    this.desktopHeader = this.el.querySelector('[data-el="desktop-header"]');
    this.mobileHeader = this.el.querySelector('[data-el="mobile-header"]');
    this.hamburger = this.el.querySelector('[data-component="hamburger"]');
    if (this.hamburger) {
      this.navList = this.el.querySelector('[data-el="nav-list"]');
      this.hamburgerOpen = this.hamburger.getAttribute('data-open');
      this.hamburger.addEventListener('state', function (e) {
        if (e.detail.state) {
          self.navList.classList.remove('hidden');
          self.navList.classList.add('flex');
        } else {
          self.navList.classList.add('hidden');
          self.navList.classList.remove('flex');
        }
      });
    }

    this.lastScrollTop = 0;
    this.isVisible = false;
    this.scrollThreshold = 50;

    // Bind scroll handler
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
    setTimeout(() => {
      this.handleScroll();
    }, 1000);

    const currentScroll = window.scrollY || document.documentElement.scrollTop;
    if (currentScroll <= 480) {
      if (this.desktopHeader) {
        this.desktopHeader.classList.remove('md:bg-fournetfournetblueopacity');
        this.desktopHeader.style.transform = 'translateY(0)';
        this.isVisible = true;
      }
    }
  }

  handleScroll() {
    const currentScroll = window.scrollY || document.documentElement.scrollTop;
    if (Math.abs(currentScroll - this.lastScrollTop) > this.scrollThreshold) {
      if (currentScroll > this.lastScrollTop && currentScroll > 0) {
        // Scrolling down
        if (this.isVisible) {
          if (this.desktopHeader) {
            this.desktopHeader.classList.remove('md:bg-fournetfournetblueopacity');
            this.desktopHeader.style.transform = 'translateY(-100%)';
          }
          if (this.mobileHeader) {
          }
          this.isVisible = false;
        }
      } else {
        // Scrolling up
        if (!this.isVisible) {
          if (this.desktopHeader) {
            this.desktopHeader.classList.add('md:bg-fournetfournetblueopacity');
            this.desktopHeader.style.transform = 'translateY(0)';
          }
          if (this.mobileHeader) {
            this.mobileHeader.classList.add('bg-fournetfournetblueopacity');
          }
          this.isVisible = true;
        }
      }

      if (currentScroll <= 480) {
        if (this.desktopHeader) {
          this.desktopHeader.classList.remove('md:bg-fournetfournetblueopacity');
        }
        if (this.mobileHeader) {
          this.mobileHeader.classList.remove('bg-fournetfournetblueopacity');
        }
      } else {
        if (this.mobileHeader) {
          this.mobileHeader.classList.add('bg-fournetfournetblueopacity');
        }
      }
      this.lastScrollTop = currentScroll;
    }
  }
}
